webpackJsonp([179293558553725],{

/***/ 613:
/***/ (function(module, exports) {

	/**
	 * A specialized version of `_.reduce` for arrays without support for
	 * iteratee shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @param {*} [accumulator] The initial value.
	 * @param {boolean} [initAccum] Specify using the first element of `array` as
	 *  the initial value.
	 * @returns {*} Returns the accumulated value.
	 */
	function arrayReduce(array, iteratee, accumulator, initAccum) {
	  var index = -1,
	      length = array == null ? 0 : array.length;
	
	  if (initAccum && length) {
	    accumulator = array[++index];
	  }
	  while (++index < length) {
	    accumulator = iteratee(accumulator, array[index], index, array);
	  }
	  return accumulator;
	}
	
	module.exports = arrayReduce;


/***/ }),

/***/ 615:
/***/ (function(module, exports) {

	/** Used to match words composed of alphanumeric characters. */
	var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
	
	/**
	 * Splits an ASCII `string` into an array of its words.
	 *
	 * @private
	 * @param {string} The string to inspect.
	 * @returns {Array} Returns the words of `string`.
	 */
	function asciiWords(string) {
	  return string.match(reAsciiWord) || [];
	}
	
	module.exports = asciiWords;


/***/ }),

/***/ 630:
/***/ (function(module, exports) {

	/**
	 * The base implementation of `_.propertyOf` without support for deep paths.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Function} Returns the new accessor function.
	 */
	function basePropertyOf(object) {
	  return function(key) {
	    return object == null ? undefined : object[key];
	  };
	}
	
	module.exports = basePropertyOf;


/***/ }),

/***/ 645:
/***/ (function(module, exports, __webpack_require__) {

	var arrayReduce = __webpack_require__(613),
	    deburr = __webpack_require__(668),
	    words = __webpack_require__(690);
	
	/** Used to compose unicode capture groups. */
	var rsApos = "['\u2019]";
	
	/** Used to match apostrophes. */
	var reApos = RegExp(rsApos, 'g');
	
	/**
	 * Creates a function like `_.camelCase`.
	 *
	 * @private
	 * @param {Function} callback The function to combine each word.
	 * @returns {Function} Returns the new compounder function.
	 */
	function createCompounder(callback) {
	  return function(string) {
	    return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
	  };
	}
	
	module.exports = createCompounder;


/***/ }),

/***/ 650:
/***/ (function(module, exports, __webpack_require__) {

	var basePropertyOf = __webpack_require__(630);
	
	/** Used to map Latin Unicode letters to basic Latin letters. */
	var deburredLetters = {
	  // Latin-1 Supplement block.
	  '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
	  '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
	  '\xc7': 'C',  '\xe7': 'c',
	  '\xd0': 'D',  '\xf0': 'd',
	  '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
	  '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
	  '\xcc': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
	  '\xec': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
	  '\xd1': 'N',  '\xf1': 'n',
	  '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
	  '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
	  '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
	  '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
	  '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
	  '\xc6': 'Ae', '\xe6': 'ae',
	  '\xde': 'Th', '\xfe': 'th',
	  '\xdf': 'ss',
	  // Latin Extended-A block.
	  '\u0100': 'A',  '\u0102': 'A', '\u0104': 'A',
	  '\u0101': 'a',  '\u0103': 'a', '\u0105': 'a',
	  '\u0106': 'C',  '\u0108': 'C', '\u010a': 'C', '\u010c': 'C',
	  '\u0107': 'c',  '\u0109': 'c', '\u010b': 'c', '\u010d': 'c',
	  '\u010e': 'D',  '\u0110': 'D', '\u010f': 'd', '\u0111': 'd',
	  '\u0112': 'E',  '\u0114': 'E', '\u0116': 'E', '\u0118': 'E', '\u011a': 'E',
	  '\u0113': 'e',  '\u0115': 'e', '\u0117': 'e', '\u0119': 'e', '\u011b': 'e',
	  '\u011c': 'G',  '\u011e': 'G', '\u0120': 'G', '\u0122': 'G',
	  '\u011d': 'g',  '\u011f': 'g', '\u0121': 'g', '\u0123': 'g',
	  '\u0124': 'H',  '\u0126': 'H', '\u0125': 'h', '\u0127': 'h',
	  '\u0128': 'I',  '\u012a': 'I', '\u012c': 'I', '\u012e': 'I', '\u0130': 'I',
	  '\u0129': 'i',  '\u012b': 'i', '\u012d': 'i', '\u012f': 'i', '\u0131': 'i',
	  '\u0134': 'J',  '\u0135': 'j',
	  '\u0136': 'K',  '\u0137': 'k', '\u0138': 'k',
	  '\u0139': 'L',  '\u013b': 'L', '\u013d': 'L', '\u013f': 'L', '\u0141': 'L',
	  '\u013a': 'l',  '\u013c': 'l', '\u013e': 'l', '\u0140': 'l', '\u0142': 'l',
	  '\u0143': 'N',  '\u0145': 'N', '\u0147': 'N', '\u014a': 'N',
	  '\u0144': 'n',  '\u0146': 'n', '\u0148': 'n', '\u014b': 'n',
	  '\u014c': 'O',  '\u014e': 'O', '\u0150': 'O',
	  '\u014d': 'o',  '\u014f': 'o', '\u0151': 'o',
	  '\u0154': 'R',  '\u0156': 'R', '\u0158': 'R',
	  '\u0155': 'r',  '\u0157': 'r', '\u0159': 'r',
	  '\u015a': 'S',  '\u015c': 'S', '\u015e': 'S', '\u0160': 'S',
	  '\u015b': 's',  '\u015d': 's', '\u015f': 's', '\u0161': 's',
	  '\u0162': 'T',  '\u0164': 'T', '\u0166': 'T',
	  '\u0163': 't',  '\u0165': 't', '\u0167': 't',
	  '\u0168': 'U',  '\u016a': 'U', '\u016c': 'U', '\u016e': 'U', '\u0170': 'U', '\u0172': 'U',
	  '\u0169': 'u',  '\u016b': 'u', '\u016d': 'u', '\u016f': 'u', '\u0171': 'u', '\u0173': 'u',
	  '\u0174': 'W',  '\u0175': 'w',
	  '\u0176': 'Y',  '\u0177': 'y', '\u0178': 'Y',
	  '\u0179': 'Z',  '\u017b': 'Z', '\u017d': 'Z',
	  '\u017a': 'z',  '\u017c': 'z', '\u017e': 'z',
	  '\u0132': 'IJ', '\u0133': 'ij',
	  '\u0152': 'Oe', '\u0153': 'oe',
	  '\u0149': "'n", '\u017f': 's'
	};
	
	/**
	 * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
	 * letters to basic Latin letters.
	 *
	 * @private
	 * @param {string} letter The matched letter to deburr.
	 * @returns {string} Returns the deburred letter.
	 */
	var deburrLetter = basePropertyOf(deburredLetters);
	
	module.exports = deburrLetter;


/***/ }),

/***/ 657:
/***/ (function(module, exports) {

	/** Used to detect strings that need a more robust regexp to match words. */
	var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
	
	/**
	 * Checks if `string` contains a word composed of Unicode symbols.
	 *
	 * @private
	 * @param {string} string The string to inspect.
	 * @returns {boolean} Returns `true` if a word is found, else `false`.
	 */
	function hasUnicodeWord(string) {
	  return reHasUnicodeWord.test(string);
	}
	
	module.exports = hasUnicodeWord;


/***/ }),

/***/ 666:
/***/ (function(module, exports) {

	/** Used to compose unicode character classes. */
	var rsAstralRange = '\\ud800-\\udfff',
	    rsComboMarksRange = '\\u0300-\\u036f',
	    reComboHalfMarksRange = '\\ufe20-\\ufe2f',
	    rsComboSymbolsRange = '\\u20d0-\\u20ff',
	    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
	    rsDingbatRange = '\\u2700-\\u27bf',
	    rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff',
	    rsMathOpRange = '\\xac\\xb1\\xd7\\xf7',
	    rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf',
	    rsPunctuationRange = '\\u2000-\\u206f',
	    rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000',
	    rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde',
	    rsVarRange = '\\ufe0e\\ufe0f',
	    rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;
	
	/** Used to compose unicode capture groups. */
	var rsApos = "['\u2019]",
	    rsBreak = '[' + rsBreakRange + ']',
	    rsCombo = '[' + rsComboRange + ']',
	    rsDigits = '\\d+',
	    rsDingbat = '[' + rsDingbatRange + ']',
	    rsLower = '[' + rsLowerRange + ']',
	    rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']',
	    rsFitz = '\\ud83c[\\udffb-\\udfff]',
	    rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
	    rsNonAstral = '[^' + rsAstralRange + ']',
	    rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
	    rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
	    rsUpper = '[' + rsUpperRange + ']',
	    rsZWJ = '\\u200d';
	
	/** Used to compose unicode regexes. */
	var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')',
	    rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')',
	    rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?',
	    rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?',
	    reOptMod = rsModifier + '?',
	    rsOptVar = '[' + rsVarRange + ']?',
	    rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
	    rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])',
	    rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])',
	    rsSeq = rsOptVar + reOptMod + rsOptJoin,
	    rsEmoji = '(?:' + [rsDingbat, rsRegional, rsSurrPair].join('|') + ')' + rsSeq;
	
	/** Used to match complex or compound words. */
	var reUnicodeWord = RegExp([
	  rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [rsBreak, rsUpper, '$'].join('|') + ')',
	  rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [rsBreak, rsUpper + rsMiscLower, '$'].join('|') + ')',
	  rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
	  rsUpper + '+' + rsOptContrUpper,
	  rsOrdUpper,
	  rsOrdLower,
	  rsDigits,
	  rsEmoji
	].join('|'), 'g');
	
	/**
	 * Splits a Unicode `string` into an array of its words.
	 *
	 * @private
	 * @param {string} The string to inspect.
	 * @returns {Array} Returns the words of `string`.
	 */
	function unicodeWords(string) {
	  return string.match(reUnicodeWord) || [];
	}
	
	module.exports = unicodeWords;


/***/ }),

/***/ 668:
/***/ (function(module, exports, __webpack_require__) {

	var deburrLetter = __webpack_require__(650),
	    toString = __webpack_require__(229);
	
	/** Used to match Latin Unicode letters (excluding mathematical operators). */
	var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
	
	/** Used to compose unicode character classes. */
	var rsComboMarksRange = '\\u0300-\\u036f',
	    reComboHalfMarksRange = '\\ufe20-\\ufe2f',
	    rsComboSymbolsRange = '\\u20d0-\\u20ff',
	    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange;
	
	/** Used to compose unicode capture groups. */
	var rsCombo = '[' + rsComboRange + ']';
	
	/**
	 * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
	 * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
	 */
	var reComboMark = RegExp(rsCombo, 'g');
	
	/**
	 * Deburrs `string` by converting
	 * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
	 * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
	 * letters to basic Latin letters and removing
	 * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category String
	 * @param {string} [string=''] The string to deburr.
	 * @returns {string} Returns the deburred string.
	 * @example
	 *
	 * _.deburr('déjà vu');
	 * // => 'deja vu'
	 */
	function deburr(string) {
	  string = toString(string);
	  return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
	}
	
	module.exports = deburr;


/***/ }),

/***/ 678:
/***/ (function(module, exports, __webpack_require__) {

	var createCompounder = __webpack_require__(645);
	
	/**
	 * Converts `string` to
	 * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category String
	 * @param {string} [string=''] The string to convert.
	 * @returns {string} Returns the kebab cased string.
	 * @example
	 *
	 * _.kebabCase('Foo Bar');
	 * // => 'foo-bar'
	 *
	 * _.kebabCase('fooBar');
	 * // => 'foo-bar'
	 *
	 * _.kebabCase('__FOO_BAR__');
	 * // => 'foo-bar'
	 */
	var kebabCase = createCompounder(function(result, word, index) {
	  return result + (index ? '-' : '') + word.toLowerCase();
	});
	
	module.exports = kebabCase;


/***/ }),

/***/ 690:
/***/ (function(module, exports, __webpack_require__) {

	var asciiWords = __webpack_require__(615),
	    hasUnicodeWord = __webpack_require__(657),
	    toString = __webpack_require__(229),
	    unicodeWords = __webpack_require__(666);
	
	/**
	 * Splits `string` into an array of its words.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category String
	 * @param {string} [string=''] The string to inspect.
	 * @param {RegExp|string} [pattern] The pattern to match words.
	 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	 * @returns {Array} Returns the words of `string`.
	 * @example
	 *
	 * _.words('fred, barney, & pebbles');
	 * // => ['fred', 'barney', 'pebbles']
	 *
	 * _.words('fred, barney, & pebbles', /[^, ]+/g);
	 * // => ['fred', 'barney', '&', 'pebbles']
	 */
	function words(string, pattern, guard) {
	  string = toString(string);
	  pattern = guard ? undefined : pattern;
	
	  if (pattern === undefined) {
	    return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
	  }
	  return string.match(pattern) || [];
	}
	
	module.exports = words;


/***/ }),

/***/ 3679:
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ 3680:
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ 3681:
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ 1053:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.disorderStyle = exports.disorderWrapStyle = exports.aboutCardsStyle = exports.aboutCardStyle = exports.treatmentBannerInnerStyle = exports.purpleImageStyle = exports.treatmentBannerStyle = exports.innerWrapperStyle = exports.blockquoteStyle = exports.experienceCardStyle = exports.experienceCardInnerStyle = exports.experienceTitleStyle = exports.textStyle = exports.statisticStyle = exports.greyStatisticsColumnStyle = exports.greyStatisticsWrapStyle = exports.greyTitleStyle = exports.statisticsRightStyle = exports.statisticsCenterStyle = exports.statisticsLeftStyle = exports.statisticsWrapStyle = exports.titleStyle = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _css, _css2, _css3, _css4, _css5, _css6, _css8, _css9, _css11, _css12;
	
	var _emotion = __webpack_require__(6);
	
	var _globalStyles = __webpack_require__(4);
	
	var _quoteBg = __webpack_require__(3680);
	
	var _quoteBg2 = _interopRequireDefault(_quoteBg);
	
	var _mediaIcon = __webpack_require__(168);
	
	var _mediaIcon2 = _interopRequireDefault(_mediaIcon);
	
	var _blockquoteBg = __webpack_require__(3679);
	
	var _blockquoteBg2 = _interopRequireDefault(_blockquoteBg);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var conditionsHash = {
		'anorexia-nervosa': _globalStyles.orange,
		'bulimia-nervosa': _globalStyles.pink,
		'binge-eating-disorder': _globalStyles.aqua
	};
	
	var titleStyle = exports.titleStyle = (0, _emotion.cx)(_globalStyles.headingLarge, /*#__PURE__*/(0, _emotion.css)({
		marginBottom: '24px'
	}));
	
	var statisticsWrapStyle = /*#__PURE__*/exports.statisticsWrapStyle = (0, _emotion.css)((_css = {
		display: 'flex',
		flexDirection: 'row',
		justifyContent: 'space-between',
		alignItems: 'center'
	}, _css['@media (max-width: ' + _globalStyles.tabletPortraitMaxWidthBreakpoint + 'px)'] = {
		display: 'table'
	}, _css));
	
	var statisticsLeftStyle = /*#__PURE__*/exports.statisticsLeftStyle = (0, _emotion.css)((_css2 = {
		width: '354px',
		boxSizing: 'content-box',
		'& h2': /*#__PURE__*/(0, _emotion.css)(_extends({}, _globalStyles.museo900, {
			fontSize: '64px',
			lineHeight: '77px',
			fontWeight: 'normal',
			margin: 0,
			color: _globalStyles.burnedOrange
		})),
		'& p': (0, _emotion.cx)(_globalStyles.textBlock, /*#__PURE__*/(0, _emotion.css)({
			margin: 0,
			color: _globalStyles.darkGrey
		}))
	}, _css2['@media (max-width: ' + _globalStyles.tabletLandscapeMaxWidthBreakpoint + 'px)'] = {
		'& h2': (0, _emotion.cx)(_globalStyles.headingLarge, /*#__PURE__*/(0, _emotion.css)({
			color: _globalStyles.burnedOrange
		}))
	}, _css2['@media (max-width: ' + _globalStyles.tabletPortraitMaxWidthBreakpoint + 'px)'] = {
		display: 'table-row',
		width: '100%',
		'& p': {
			marginBottom: '60px'
		}
	}, _css2['@media (max-width: ' + _globalStyles.mobileMaxWidthBreakpoint + 'px)'] = {
		width: '100%',
		'& p': {
			marginBottom: '24px'
		}
	}, _css2));
	
	var statisticsCenterStyle = /*#__PURE__*/exports.statisticsCenterStyle = (0, _emotion.css)((_css3 = {
		margin: '0 25px',
		textAlign: 'center',
		'& img': {
			width: '297px'
		}
	}, _css3['@media (max-width: ' + _globalStyles.tabletLandscapeMaxWidthBreakpoint + 'px)'] = {
		'& img': {
			width: '234px'
		}
	}, _css3['@media (max-width: ' + _globalStyles.tabletPortraitMaxWidthBreakpoint + 'px)'] = {
		display: 'table-cell',
		verticalAlign: 'top',
		width: '50%'
	}, _css3['@media (max-width: ' + _globalStyles.mobileMaxWidthBreakpoint + 'px)'] = {
		display: 'none'
	}, _css3));
	
	var statisticsRightStyle = /*#__PURE__*/exports.statisticsRightStyle = (0, _emotion.css)((_css4 = {
		width: '300px',
		'& ul': {
			padding: 0,
			margin: 0
		}
	}, _css4['@media (max-width: ' + _globalStyles.tabletPortraitMaxWidthBreakpoint + 'px)'] = {
		display: 'table-cell',
		verticalAlign: 'top',
		width: '50%'
	}, _css4['@media (max-width: ' + _globalStyles.mobileMaxWidthBreakpoint + 'px)'] = {
		width: '100%'
	}, _css4));
	
	var greyTitleStyle = exports.greyTitleStyle = (0, _emotion.cx)(titleStyle, /*#__PURE__*/(0, _emotion.css)((_css5 = {
		color: '#fff',
		maxWidth: '600px'
	}, _css5['@media (max-width: ' + _globalStyles.tabletLandscapeMaxWidthBreakpoint + 'px)'] = {
		maxWidth: 'initial'
	}, _css5)));
	
	var greyStatisticsWrapStyle = /*#__PURE__*/exports.greyStatisticsWrapStyle = (0, _emotion.css)((_css6 = {
		display: 'flex',
		flexDirection: 'row',
		justifyContent: 'space-between',
		alignItems: 'center',
		'& > div': {
			width: '320px'
		},
		'& p': {
			color: '#fff'
		}
	}, _css6['@media (max-width: ' + _globalStyles.tabletLandscapeMaxWidthBreakpoint + 'px)'] = {
		flexDirection: 'column',
		'& > div': {
			marginTop: '60px',
			width: '100%'
		}
	}, _css6['@media (max-width: ' + _globalStyles.mobileMaxWidthBreakpoint + 'px)'] = {
		'& > div': {
			marginTop: '30px'
		}
	}, _css6));
	
	var greyStatisticsColumnStyle = exports.greyStatisticsColumnStyle = function greyStatisticsColumnStyle(condition) {
		var _css7;
	
		return (/*#__PURE__*/(0, _emotion.css)((_css7 = {
				'& em, & strong': {
					color: conditionsHash[condition],
					fontStyle: 'normal',
					fontWeight: 'normal'
				},
				'& > em': _extends({}, _globalStyles.museo900, {
					fontSize: '58px',
					lineHeight: '1',
					fontWeight: 'normal',
					'& > span': _extends({}, _globalStyles.museo500, {
						fontSize: '18px',
						lineHeight: '22px',
						color: '#fff',
						marginLeft: '9px',
						letterSpacing: '0.5px',
						top: '-4px',
						position: 'relative',
						display: 'inline-block'
					})
				}),
	
				'& p': {
					margin: '0',
					color: '#fff'
				}
			}, _css7['@media (max-width: ' + _globalStyles.mobileMaxWidthBreakpoint + 'px)'] = {
				'& > em': {
					fontSize: '30px',
					lineHeight: '36px'
				}
			}, _css7))
		);
	};
	
	var statisticStyle = exports.statisticStyle = function statisticStyle(condition) {
		return (/*#__PURE__*/(0, _emotion.css)({
				listStyle: 'none',
				'& h2': (0, _emotion.cx)(_globalStyles.headingLarge, /*#__PURE__*/(0, _emotion.css)({
					fontWeight: 'normal',
					marginBottom: '0'
				})),
				'& p': {
					margin: '0'
				},
	
				'& h2, & p span': {
					color: conditionsHash[condition]
				},
				'&:not(:last-child)': {
					marginBottom: '24px'
				}
			})
		);
	};
	
	var textStyle = exports.textStyle = (0, _emotion.cx)(_globalStyles.textBlock, /*#__PURE__*/(0, _emotion.css)({
		'& p': {
			maxWidth: '800px'
		}
	}));
	
	var experienceTitleStyle = exports.experienceTitleStyle = (0, _emotion.cx)(_globalStyles.headingMedium, /*#__PURE__*/(0, _emotion.css)({
		fontWeight: 'normal'
	}));
	
	var experienceCardInnerStyle = /*#__PURE__*/exports.experienceCardInnerStyle = (0, _emotion.css)({
		position: 'absolute',
		bottom: '24px',
		left: '24px'
	});
	
	var experienceCardStyle = exports.experienceCardStyle = function experienceCardStyle(background, hasVideo) {
		var _extends2;
	
		return (/*#__PURE__*/(0, _emotion.css)(_extends({
				borderRadius: '6px',
				maxWidth: '376px',
				height: '212px',
				position: 'relative'
			}, hasVideo ? {
				background: 'url(' + _mediaIcon2.default + '), linear-gradient(\n\t\t\t\t\t\trgba(36, 36, 36, 0.6), \n\t\t\t\t\t\trgba(36, 36, 36, 0.6)\n\t\t  ), url(\'' + background + '\')',
				backgroundRepeat: 'no-repeat',
				backgroundPosition: 'center 30px, center center, top center',
				backgroundSize: '56px 56px, cover, cover'
			} : {
				background: 'linear-gradient(\n\t\t\trgba(36, 36, 36, 0.6), \n\t\t\trgba(36, 36, 36, 0.6)\n\t\t  ), url(\'' + background + '\')',
				backgroundRepeat: 'no-repeat',
				backgroundPosition: 'center center, top center',
				backgroundSize: 'cover, cover'
			}, (_extends2 = {
				'& h2': (0, _emotion.cx)(_globalStyles.label, /*#__PURE__*/(0, _emotion.css)({
					color: '#fff',
					marginBottom: '12px'
				})),
				'& p': (0, _emotion.cx)(_globalStyles.headingSmallLight, /*#__PURE__*/(0, _emotion.css)({
					color: '#fff',
					margin: '0'
				}))
			}, _extends2['@media (max-width: ' + _globalStyles.tabletPortraitMaxWidthBreakpoint + 'px)'] = {
				'& p': {
					display: 'none'
				}
			}, _extends2)))
		);
	};
	
	var blockquoteStyle = exports.blockquoteStyle = (0, _emotion.cx)(_globalStyles.headingLarge, /*#__PURE__*/(0, _emotion.css)((_css8 = {
		maxWidth: '1000px',
		padding: '22px 0 0 26px',
		background: 'transparent url(' + _blockquoteBg2.default + ') no-repeat 0 0'
	}, _css8['@media (max-width: ' + _globalStyles.mobileMaxWidthBreakpoint + 'px)'] = _globalStyles.headingMedium, _css8)));
	
	var innerWrapperStyle = /*#__PURE__*/exports.innerWrapperStyle = (0, _emotion.css)({
		maxWidth: _globalStyles.desktopMaxWidthBreakpoint,
		width: '100%',
		height: '100%',
		margin: '0 auto',
		padding: '0 20px',
		overflowX: 'hidden'
	});
	
	var treatmentBannerStyle = /*#__PURE__*/exports.treatmentBannerStyle = (0, _emotion.css)((_css9 = {
		background: _globalStyles.purple,
		position: 'relative',
		width: '100%',
		height: '280px'
	}, _css9['@media (max-width: ' + _globalStyles.mobileMaxWidthBreakpoint + 'px)'] = {
		height: 'auto',
		padding: '30px 0'
	}, _css9));
	
	var purpleImageStyle = exports.purpleImageStyle = function purpleImageStyle(background) {
		var _css10;
	
		return (/*#__PURE__*/(0, _emotion.css)((_css10 = {
				position: 'absolute',
				top: 0,
				right: 0,
				width: '517px',
				height: '100%',
				background: 'transparent url(' + background + ') no-repeat center center',
				backgroundSize: 'cover'
			}, _css10['@media (max-width: ' + _globalStyles.tabletLandscapeMaxWidthBreakpoint + 'px)'] = {
				display: 'none'
			}, _css10))
		);
	};
	
	var treatmentBannerInnerStyle = /*#__PURE__*/exports.treatmentBannerInnerStyle = (0, _emotion.css)((_css11 = {
		position: 'relative',
		top: '50%',
		transform: 'translateY(-50%)',
		paddingRight: '517px',
		'& > div': (0, _emotion.cx)(_globalStyles.headingXLarge, /*#__PURE__*/(0, _emotion.css)({
			color: '#fff'
		})),
	
		'& strong': {
			fontWeight: 'normal',
			color: _globalStyles.aqua
		},
		'& p': {
			margin: 0
		}
	}, _css11['@media (max-width: ' + _globalStyles.tabletLandscapeMaxWidthBreakpoint + 'px)'] = {
		paddingRight: '0',
		textAlign: 'center'
	}, _css11['@media (max-width: ' + _globalStyles.mobileMaxWidthBreakpoint + 'px)'] = {
		top: '0',
		transform: 'none'
	}, _css11));
	
	var aboutCardStyle = exports.aboutCardStyle = function aboutCardStyle(colour) {
		return (/*#__PURE__*/(0, _emotion.css)({
				borderRadius: '4px',
				padding: '24px',
				background: colour + ' url(' + _quoteBg2.default + ') no-repeat 24px 12px',
				position: 'relative',
				minHeight: '180px',
				'& span': (0, _emotion.cx)(_globalStyles.textBlock, /*#__PURE__*/(0, _emotion.css)({
					color: '#fff',
					display: 'block',
					position: 'relative',
					top: '50%',
					transform: 'translateY(-50%)'
				}))
			})
		);
	};
	
	var aboutCardsStyle = exports.aboutCardsStyle = (0, _emotion.cx)((0, _globalStyles.cardSection)(0), /*#__PURE__*/(0, _emotion.css)({
		marginTop: '60px',
		maxWidth: '944px'
	}));
	
	var disorderWrapStyle = /*#__PURE__*/exports.disorderWrapStyle = (0, _emotion.css)((_css12 = {
		display: 'flex',
		flexDirection: 'row',
		flexWrap: 'wrap',
		justifyContent: 'space-between',
		alignItems: 'top',
		padding: '0'
	
	}, _css12['@media (max-width: ' + _globalStyles.mobileMaxWidthBreakpoint + 'px)'] = {
		margin: '20px 0'
	}, _css12));
	
	var disorderStyle = exports.disorderStyle = function disorderStyle(color) {
		var _css13;
	
		return (/*#__PURE__*/(0, _emotion.css)((_css13 = {
				display: 'block',
				listStyle: 'none',
				padding: '0',
				margin: '40px 0',
				width: '480px',
				'& h2': (0, _emotion.cx)(_globalStyles.headingMedium, /*#__PURE__*/(0, _emotion.css)({
					color: color,
					marginBottom: '6px'
				})),
	
				'& p': {
					margin: '0'
				}
			}, _css13['@media (max-width: ' + _globalStyles.mobileMaxWidthBreakpoint + 'px)'] = {
				margin: '20px 0'
			}, _css13))
		);
	};
	
	//headingMedium

/***/ }),

/***/ 1077:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactHelmet = __webpack_require__(8);
	
	var _kebabCase = __webpack_require__(678);
	
	var _kebabCase2 = _interopRequireDefault(_kebabCase);
	
	var _navManager = __webpack_require__(22);
	
	var _resourceLibraryManager = __webpack_require__(74);
	
	var _link = __webpack_require__(9);
	
	var _cards = __webpack_require__(17);
	
	var _resourceCard = __webpack_require__(30);
	
	var _pageHeader = __webpack_require__(19);
	
	var _aboutEatingDisorders = __webpack_require__(1053);
	
	var _statisticsChart = __webpack_require__(3681);
	
	var _statisticsChart2 = _interopRequireDefault(_statisticsChart);
	
	var _globalStyles = __webpack_require__(4);
	
	var _colourManager = __webpack_require__(173);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ResourcePropType = _propTypes2.default.shape({
		title: _propTypes2.default.string,
		type: _propTypes2.default.string,
		date: _propTypes2.default.string,
		fields: _propTypes2.default.shape({
			thumbnail_image: _propTypes2.default.shape({
				childImageSharp: _propTypes2.default.shape({
					resize: _propTypes2.default.shape({
						src: _propTypes2.default.string.isRequired
					}).isRequired
				}).isRequired
			}).isRequired
		}).isRequired,
		attachments: _propTypes2.default.arrayOf(_propTypes2.default.shape({
			vimeo_url: _propTypes2.default.string
		}))
	}).isRequired;
	
	var AboutEatingDisordersPage = function (_React$PureComponent) {
		_inherits(AboutEatingDisordersPage, _React$PureComponent);
	
		function AboutEatingDisordersPage() {
			_classCallCheck(this, AboutEatingDisordersPage);
	
			return _possibleConstructorReturn(this, _React$PureComponent.apply(this, arguments));
		}
	
		AboutEatingDisordersPage.prototype.render = function render() {
			var _ref;
	
			var pageSettings = this.props.data.page.edges[0].node;
	
			var resources = [pageSettings.resource_1, pageSettings.resource_2, pageSettings.resource_3, pageSettings.resource_4];
	
			return _react2.default.createElement(
				'div',
				{ className: _aboutEatingDisorders.wrapperStyle },
				_react2.default.createElement(
					_reactHelmet.Helmet,
					{ title: pageSettings.teal_heading },
					_react2.default.createElement('meta', { property: 'og:type', content: 'website' }),
					_react2.default.createElement('meta', { property: 'og:title', content: pageSettings.teal_heading }),
					_react2.default.createElement('meta', { name: 'description', content: pageSettings.teal_body }),
					_react2.default.createElement('meta', { property: 'og:description', content: pageSettings.teal_body })
				),
				_react2.default.createElement(_pageHeader.PageHeader, {
					background: _globalStyles.aqua,
					titleText: pageSettings.teal_heading,
					subTitleText: pageSettings.teal_body,
					subTitleTextColor: '#fff',
					titleTextColor: '#fff'
				}),
				_react2.default.createElement(
					'section',
					{ className: (0, _globalStyles.contentSection)('#fff') },
					_react2.default.createElement(
						'div',
						{ className: _aboutEatingDisorders.innerWrapperStyle },
						_react2.default.createElement(
							'header',
							null,
							_react2.default.createElement(
								'h1',
								{ className: _aboutEatingDisorders.titleStyle },
								pageSettings.heading_1
							)
						),
						_react2.default.createElement('div', {
							className: _aboutEatingDisorders.textStyle,
							dangerouslySetInnerHTML: {
								__html: pageSettings.body_1
							}
						})
					),
					_react2.default.createElement(
						'div',
						{ className: _aboutEatingDisorders.innerWrapperStyle },
						_react2.default.createElement(
							'div',
							{ className: _aboutEatingDisorders.aboutCardsStyle },
							_react2.default.createElement(
								_cards.Cards,
								{
									columns: 2,
									scrollable: false,
									columnsAt: (_ref = {}, _ref['max-width: ' + _globalStyles.tabletPortraitMaxWidthBreakpoint] = 1, _ref)
								},
								pageSettings.quotes.map(function (quoteItem, i) {
									return _react2.default.createElement(
										'p',
										{
											key: i,
											'data-component': 'Card',
											className: (0, _aboutEatingDisorders.aboutCardStyle)((0, _colourManager.descriptionToHex)(quoteItem.colour))
										},
										_react2.default.createElement(
											'span',
											null,
											quoteItem.quote
										)
									);
								})
							)
						)
					)
				),
				_react2.default.createElement(
					'section',
					{ className: (0, _globalStyles.contentSection)() },
					_react2.default.createElement(
						'div',
						{ className: _aboutEatingDisorders.innerWrapperStyle },
						_react2.default.createElement(
							'header',
							null,
							_react2.default.createElement(
								'h1',
								{ className: _aboutEatingDisorders.titleStyle },
								pageSettings.heading_2
							)
						),
						_react2.default.createElement(
							'div',
							{ className: _aboutEatingDisorders.statisticsWrapStyle },
							_react2.default.createElement(
								'div',
								{ className: _aboutEatingDisorders.statisticsLeftStyle },
								_react2.default.createElement(
									'h2',
									null,
									pageSettings.statistic
								),
								_react2.default.createElement(
									'p',
									null,
									pageSettings.body_2
								)
							),
							_react2.default.createElement(
								'div',
								{ className: _aboutEatingDisorders.statisticsCenterStyle },
								_react2.default.createElement('img', { src: _statisticsChart2.default, alt: '' })
							),
							_react2.default.createElement(
								'div',
								{ className: _aboutEatingDisorders.statisticsRightStyle },
								_react2.default.createElement(
									'ul',
									null,
									pageSettings.pie_chart_data.map(function (data, i) {
										return _react2.default.createElement(
											'li',
											{ key: i, className: (0, _aboutEatingDisorders.statisticStyle)((0, _kebabCase2.default)(data.condition)) },
											_react2.default.createElement(
												'h2',
												null,
												data.value_description
											),
											_react2.default.createElement(
												'p',
												null,
												data.cohort_description,
												' ',
												_react2.default.createElement(
													'span',
													null,
													data.condition
												)
											)
										);
									})
								)
							)
						)
					)
				),
				_react2.default.createElement(
					'section',
					{ className: (0, _globalStyles.contentSection)(_globalStyles.darkBlueGrey, 80) },
					_react2.default.createElement(
						'div',
						{ className: _aboutEatingDisorders.innerWrapperStyle },
						_react2.default.createElement(
							'header',
							null,
							_react2.default.createElement(
								'h1',
								{ className: _aboutEatingDisorders.greyTitleStyle },
								pageSettings.heading_3
							)
						),
						_react2.default.createElement(
							'div',
							{ className: _aboutEatingDisorders.greyStatisticsWrapStyle },
							_react2.default.createElement(
								'div',
								{ className: (0, _aboutEatingDisorders.greyStatisticsColumnStyle)('anorexia-nervosa') },
								_react2.default.createElement(
									'em',
									null,
									pageSettings.statistic_1_3,
									_react2.default.createElement(
										'span',
										null,
										pageSettings.statistic_unit_1_3
									)
								),
								_react2.default.createElement('div', {
									dangerouslySetInnerHTML: {
										__html: pageSettings.statistic_description_1_3
									}
								})
							),
							_react2.default.createElement(
								'div',
								{ className: (0, _aboutEatingDisorders.greyStatisticsColumnStyle)('anorexia-nervosa') },
								_react2.default.createElement(
									'em',
									null,
									pageSettings.statistic_2_3,
									_react2.default.createElement(
										'span',
										null,
										pageSettings.statistic_unit_2_3
									)
								),
								_react2.default.createElement('div', {
									dangerouslySetInnerHTML: {
										__html: pageSettings.statistic_description_2_3
									}
								})
							),
							_react2.default.createElement(
								'div',
								{ className: (0, _aboutEatingDisorders.greyStatisticsColumnStyle)('bulimia-nervosa') },
								_react2.default.createElement(
									'em',
									null,
									pageSettings.statistic_3_3,
									_react2.default.createElement(
										'span',
										null,
										pageSettings.statistic_unit_3_3
									)
								),
								_react2.default.createElement('div', {
									dangerouslySetInnerHTML: {
										__html: pageSettings.statistic_description_3_3
									}
								})
							)
						)
					)
				),
				_react2.default.createElement(
					'section',
					{ className: (0, _globalStyles.contentSection)('#fff') },
					_react2.default.createElement(
						'div',
						{ className: _aboutEatingDisorders.innerWrapperStyle },
						_react2.default.createElement(
							'blockquote',
							{ className: _aboutEatingDisorders.blockquoteStyle },
							pageSettings.quote
						)
					)
				),
				_react2.default.createElement(
					'section',
					{ className: (0, _globalStyles.contentSection)() },
					_react2.default.createElement(
						'div',
						{ className: _aboutEatingDisorders.innerWrapperStyle },
						_react2.default.createElement(
							'div',
							{ className: (0, _globalStyles.cardSection)(0) },
							_react2.default.createElement(
								'header',
								null,
								_react2.default.createElement(
									'h1',
									{ className: _aboutEatingDisorders.experienceTitleStyle },
									'People\'s Experiences'
								)
							),
							_react2.default.createElement(
								_cards.Cards,
								{ columns: 3 },
								_react2.default.createElement(
									_link.Link,
									{ href: pageSettings.video_link_1, 'data-component': 'Card' },
									_react2.default.createElement(
										'div',
										{ className: (0, _aboutEatingDisorders.experienceCardStyle)(pageSettings.video_thumbnail_1, true) },
										_react2.default.createElement(
											'div',
											{ className: _aboutEatingDisorders.experienceCardInnerStyle },
											_react2.default.createElement(
												'h2',
												null,
												pageSettings.video_subject_1
											),
											_react2.default.createElement(
												'p',
												null,
												pageSettings.video_description_1
											)
										)
									)
								),
								_react2.default.createElement(
									_link.Link,
									{ href: pageSettings.video_link_2, 'data-component': 'Card' },
									_react2.default.createElement(
										'div',
										{ className: (0, _aboutEatingDisorders.experienceCardStyle)(pageSettings.video_thumbnail_2, true) },
										_react2.default.createElement(
											'div',
											{ className: _aboutEatingDisorders.experienceCardInnerStyle },
											_react2.default.createElement(
												'h2',
												null,
												pageSettings.video_subject_2
											),
											_react2.default.createElement(
												'p',
												null,
												pageSettings.video_description_2
											)
										)
									)
								),
								_react2.default.createElement(
									_link.Link,
									{ href: pageSettings.video_link_3, 'data-component': 'Card' },
									_react2.default.createElement(
										'div',
										{ className: (0, _aboutEatingDisorders.experienceCardStyle)(pageSettings.video_thumbnail_3, true) },
										_react2.default.createElement(
											'div',
											{ className: _aboutEatingDisorders.experienceCardInnerStyle },
											_react2.default.createElement(
												'h2',
												null,
												pageSettings.video_subject_3
											),
											_react2.default.createElement(
												'p',
												null,
												pageSettings.video_description_3
											)
										)
									)
								)
							)
						)
					)
				),
				_react2.default.createElement(
					'section',
					{ className: (0, _globalStyles.contentSection)('#fff') },
					_react2.default.createElement(
						'div',
						{ className: _aboutEatingDisorders.innerWrapperStyle },
						_react2.default.createElement(
							'header',
							null,
							_react2.default.createElement(
								'h1',
								{ className: _aboutEatingDisorders.titleStyle },
								pageSettings.heading_4
							)
						),
						_react2.default.createElement('div', {
							className: _aboutEatingDisorders.textStyle,
							dangerouslySetInnerHTML: {
								__html: pageSettings.body_4
							}
						}),
						_react2.default.createElement(
							'ul',
							{ className: _aboutEatingDisorders.disorderWrapStyle },
							pageSettings.eating_disorders_list.map(function (disorder, i) {
								return _react2.default.createElement(
									'li',
									{ key: i, className: (0, _aboutEatingDisorders.disorderStyle)((0, _colourManager.descriptionToHex)(disorder.colour)) },
									_react2.default.createElement(
										'h2',
										null,
										disorder.heading
									),
									_react2.default.createElement('div', {
										className: _aboutEatingDisorders.textStyle,
										dangerouslySetInnerHTML: {
											__html: disorder.body
										}
									})
								);
							})
						)
					)
				),
				pageSettings.purple_banner_text && _react2.default.createElement(
					'div',
					{ className: _aboutEatingDisorders.treatmentBannerStyle },
					_react2.default.createElement(
						'div',
						{ className: _aboutEatingDisorders.innerWrapperStyle },
						_react2.default.createElement(
							'div',
							{ className: _aboutEatingDisorders.treatmentBannerInnerStyle },
							_react2.default.createElement('div', {
								dangerouslySetInnerHTML: {
									__html: pageSettings.purple_banner_text
								}
							})
						)
					),
					_react2.default.createElement('div', { className: (0, _aboutEatingDisorders.purpleImageStyle)(pageSettings.purple_banner_image) })
				),
				_react2.default.createElement(
					'section',
					{ className: (0, _globalStyles.contentSection)() },
					_react2.default.createElement(
						'div',
						{ className: _aboutEatingDisorders.innerWrapperStyle },
						_react2.default.createElement(
							'header',
							null,
							_react2.default.createElement(
								'h1',
								{ className: _aboutEatingDisorders.titleStyle },
								'Resources'
							)
						),
						_react2.default.createElement(
							_cards.Cards,
							{ columns: 4 },
							resources.map(function (node, index) {
								return _react2.default.createElement(_resourceCard.ResourceCard, {
									key: index,
									id: node.id,
									to: (0, _navManager.idToLink)(node.id),
									background: node.fields && node.fields.thumbnail_image.childImageSharp.resize.src,
									audiences: (0, _resourceLibraryManager.extractAudiences)(node.categories),
									hasVideo: !!node.attachments.find(function (a) {
										return a.vimeo_url;
									}),
									title: node.title,
									body: node.extract
								});
							})
						)
					)
				)
			);
		};
	
		return AboutEatingDisordersPage;
	}(_react2.default.PureComponent);
	
	AboutEatingDisordersPage.propTypes = {
		data: _propTypes2.default.shape({
			page: _propTypes2.default.shape({
				edges: _propTypes2.default.arrayOf(_propTypes2.default.shape({
					node: _propTypes2.default.shape({
						teal_heading: _propTypes2.default.string.isRequired,
						teal_body: _propTypes2.default.string.isRequired,
	
						heading_1: _propTypes2.default.string.isRequired,
						body_1: _propTypes2.default.string.isRequired,
						quotes: _propTypes2.default.arrayOf(_propTypes2.default.shape({
							quote: _propTypes2.default.string.isRequired,
							colour: _propTypes2.default.string.isRequired
						})),
	
						heading_2: _propTypes2.default.string.isRequired,
						statistic: _propTypes2.default.string.isRequired,
						body_2: _propTypes2.default.string.isRequired,
						pie_chart_data: _propTypes2.default.arrayOf(_propTypes2.default.shape({
							value: _propTypes2.default.string.isRequired,
							value_description: _propTypes2.default.string.isRequired,
							cohort_description: _propTypes2.default.string.isRequired,
							condition: _propTypes2.default.string.isRequired,
							colour: _propTypes2.default.string.isRequired
						})),
	
						heading_3: _propTypes2.default.string.isRequired,
						statistic_1_3: _propTypes2.default.string.isRequired,
						statistic_description_1_3: _propTypes2.default.string.isRequired,
						statistic_2_3: _propTypes2.default.string.isRequired,
						statistic_description_2_3: _propTypes2.default.string.isRequired,
						statistic_3_3: _propTypes2.default.string.isRequired,
						statistic_description_3_3: _propTypes2.default.string.isRequired,
	
						quote: _propTypes2.default.string.isRequired,
	
						video_link_1: _propTypes2.default.string.isRequired,
						video_thumbnail_1: _propTypes2.default.string.isRequired,
						video_subject_1: _propTypes2.default.string.isRequired,
						video_description_1: _propTypes2.default.string.isRequired,
						video_link_2: _propTypes2.default.string.isRequired,
						video_thumbnail_2: _propTypes2.default.string.isRequired,
						video_subject_2: _propTypes2.default.string.isRequired,
						video_description_2: _propTypes2.default.string.isRequired,
						video_link_3: _propTypes2.default.string.isRequired,
						video_thumbnail_3: _propTypes2.default.string.isRequired,
						video_subject_3: _propTypes2.default.string.isRequired,
						video_description_3: _propTypes2.default.string.isRequired,
	
						heading_4: _propTypes2.default.string.isRequired,
						body_4: _propTypes2.default.string.isRequired,
						eating_disorders_list: _propTypes2.default.arrayOf(_propTypes2.default.shape({
							heading: _propTypes2.default.string.isRequired,
							body: _propTypes2.default.string.isRequired,
							colour: _propTypes2.default.string.isRequired
						})),
	
						purple_banner_text: _propTypes2.default.string.isRequired,
						purple_banner_image: _propTypes2.default.string.isRequired,
	
						resource_1: ResourcePropType,
						resource_2: ResourcePropType,
						resource_3: ResourcePropType,
						resource_4: ResourcePropType
					}).isRequired
				})).isRequired
			}).isRequired
		}).isRequired
	};
	exports.default = AboutEatingDisordersPage;
	var query = exports.query = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-about-eating-disorders-index-js-d965ce5da6056b0c0372.js